import { getAgent } from '@cronos-app/api';
import type { ChainLayer, ExplicitAddress } from '@cronos-app/sdk';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useGlobalChainLayer } from '../useGlobalChainLayer';
import { Agent } from './useAgents';

type useAgentOptions = UseQueryOptions<Agent> & {
  tokenAddress: ExplicitAddress | undefined;
};

export const useAgent = ({ tokenAddress, ...options }: useAgentOptions) => {
  const chainLayer = useGlobalChainLayer();
  return useQuery<Agent>({
    queryKey: ['useAgent', tokenAddress, chainLayer],
    queryFn: async () => {
      if (!tokenAddress) throw new Error('tokenAddress should no be empty');

      return fetchAgent(chainLayer, tokenAddress);
    },
    ...options,
    enabled: options.enabled === false ? false : !!tokenAddress,
  });
};

const fetchAgent = async (
  chainLayer: ChainLayer,
  tokenAddress: ExplicitAddress,
): Promise<Agent> => {
  const agent = await getAgent(chainLayer, tokenAddress);
  return new Agent(agent);
};
